import React from "react"
import * as styles from "./EmployeeIcons.module.css"
import { Link } from "gatsby"
import Manufacturing from "../../../../images/landing/employee/Manufacturing.inline.svg"
import Hospitality from "../../../../images/landing/employee/hospitality.inline.svg"
import Retail from "../../../../images/landing/employee/retail.inline.svg"
import Healthcare from "../../../../images/landing/employee/Healthcare.inline.svg"
import Realestate_Propertymanagement from "../../../../images/landing/employee/realestate-propertymanagement.inline.svg"

const icons = [
  {
    svg: Manufacturing,
    text: "Manufacturing",
    link: "/solutions/deskless-employee",
  },
  {
    svg: Hospitality,
    text: "Hospitality",
    link: "/solutions/deskless-employee",
  },
  { svg: Retail, text: "Retail", link: "/solutions/deskless-employee" },
  { svg: Healthcare, text: "Healthcare", link: "/solutions/deskless-employee" },
  {
    svg: Realestate_Propertymanagement,
    text: "Deskless Employee",
    link: "/solutions/deskless-employee",
  },
]

const EmployeeIcons = () => {
  return (
    <div className={styles.container}>
      {icons.map(({ svg: SVG, text, link }) => (
        <Link key={text} to={link}>
          <div className={styles.circleBox}>
            <div className={styles.circle}>
              <SVG />
            </div>
            <span className={styles.title}>{text}</span>
          </div>
        </Link>
      ))}
    </div>
  )
}

export default EmployeeIcons
